import { useContext } from 'react';

import { LiveKitDevicesStateContext } from './LiveKitDevicesStateContext';

const useLiveKitDevicesStateContext = () => {
  const context = useContext(LiveKitDevicesStateContext);
  if (!context) throw new Error('useLiveKitDevicesStateContext must be used within a LiveKitDevicesStateProvider');

  return context;
};

export default useLiveKitDevicesStateContext;
